import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Container, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Information from '../../PracticesPage/Components/Information';
import CustomOutlinedChip from '../../../Components/Chip/CustomOutlinedChip';

const useStyles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8%',
    alignItems: 'center',
    maxHeight: '80px',

    pt: '12px',
    pb: '12px',
  },
  icnWrap: {
    display: 'flex',
    alignItems: 'center',
  },
});

const RolesListItem = function RolesListItem({ data, onClick, userInfo }) {
  const intl = useIntl();
  const classes = useStyles();
  const { userRoles } = userInfo;
  return (
    <Container id="role-entry" sx={classes.root} style={{ maxWidth: 'unset' }}>
      <Information caption={intl.messages.ID} value={data?.id} />
      <Information caption={intl.messages.NAME} value={data?.name} />
      <Information
        caption={intl.messages.LICENCES}
        value={data?.licences?.toString() ?? intl.messages.UNLIMITED}
      />
      <Information
        caption={intl.messages.LICENCES_USED}
        value={
          <CustomOutlinedChip
            label={data?.activeUsers?.toString()}
            color={
              data?.activeUsers < data?.licences || data?.licences === null
                ? 'success.main'
                : 'error.main'
            }
            bgcolor={
              data?.activeUsers < data?.licences || data?.licences === null
                ? 'success.light'
                : 'error.light'
            }
          />
        }
      />
      <div
        style={{
          minWidth: '64px',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        {userRoles?.find(({ roleId }) => roleId === 'SUPERADMIN') &&
          data.id !== 'ACCOUNTING' && (
            <Tooltip title={intl.messages.EDIT_LICENSE} placement="bottom">
              <IconButton
                id="role-options-iconButton"
                aria-label="open-options"
                onClick={() => onClick(data)}
              >
                <EditIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          )}
      </div>
    </Container>
  );
};

RolesListItem.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  userInfo: PropTypes.array.isRequired,
};
RolesListItem.defaultProps = {
  data: {},
  onClick: () => {},
};
export default RolesListItem;
